/**
 * 河川予警報JSON取得
 */
import Util from "./../../lib/util";
import Repository from "./../JsonRepository";
import logger from "./../../lib/logger";

const resource = "";
// const timeFormat = "YYYY-MM-DD HH:mm";

export default {
  /**
   * 選択中洪水予報マスタ情報取得
   * @param {*} fldfrCd 洪水予報区間コード
   */
  getSelectedMtFldfr(fldfrCd) {
    logger.debug("json getSelectedMtFldfr(" + fldfrCd + ")");
    return Repository.get(`${resource}/master/rw/fldfr/` + fldfrCd + ".json");
  },
  /**
   *  選択中洪水予報詳細情報取得
   * @param {*} fldfrCd 洪水予報区間コード
   * @param {*} appTime 取得日時
   */
  getSelectedFldfr(fldfrCd, appTime) {
    let datePath = Util.formatDate(appTime, "YYYYMMDD/HHmm/");
    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    logger.debug("json getSelectedFldfr(" + datePath + fldfrCd + ")");
    return Repository.get(
      `${resource}/rw/detail/fldfr/` + datePath + fldfrCd + ".json"
    );
  },
  /**
   * 選択中水位周知河川情報マスタ情報取得
   * @param {*} evstgCd 水位周知河川情報区間コード
   */
  getSelectedMtEvstg(evstgCd) {
    logger.debug("json getSelectedMtEvstg(" + evstgCd + ")");
    return Repository.get(`${resource}/master/rw/evstg/` + evstgCd + ".json");
  },
  /**
   *  選択中水位周知河川詳細情報取得
   * @param {*} evstgCd 水位周知河川情報区間コード
   * @param {*} appTime 取得日時
   */
  getSelectedEvstg(evstgCd, appTime) {
    let datePath = Util.formatDate(appTime, "YYYYMMDD/HHmm/");
    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    logger.debug("json getSelectedEvstg(" + datePath + evstgCd + ")");
    return Repository.get(
      `${resource}/rw/detail/evstg/` + datePath + evstgCd + ".json"
    );
  },
  /**
   * 選択中ダム放流通知マスタ情報取得
   * @param {*} damdschCd ダム放流通知区間コード
   */
  getSelectedMtDamdsch(damdschCd) {
    logger.debug("json getSelectedMtDamdsch(" + damdschCd + ")");
    return Repository.get(
      `${resource}/master/rw/damdsch/` + damdschCd + ".json"
    );
  },
  /**
   *  選択中ダム放流通知詳細情報取得
   * @param {*} damdschCd ダム放流通知区間コード
   * @param {*} appTime 取得日時
   */
  getSelectedDamdsch(damdschCd, appTime) {
    let datePath = Util.formatDate(appTime, "YYYYMMDD/HHmm/");
    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    logger.debug("json getSelectedDamdsch(" + datePath + damdschCd + ")");
    return Repository.get(
      `${resource}/rw/detail/damdsch/` + datePath + damdschCd + ".json"
    );
  },
  /**
   * 選択中水防警報マスタ情報取得
   * @param {*} fldctlCd 水防警報区間コード
   */
  getSelectedMtFldctl(fldctlCd) {
    logger.debug("json getSelectedMtFldctl(" + fldctlCd + ")");
    return Repository.get(`${resource}/master/rw/fldctl/` + fldctlCd + ".json");
  },
  /**
   *  選択中水防警報詳細情報取得
   * @param {*} fldctlCd 水防警報区間コード
   * @param {*} appTime 取得日時
   */
  getSelectedFldctl(fldctlCd, appTime) {
    let datePath = Util.formatDate(appTime, "YYYYMMDD/HHmm/");
    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    logger.debug("json getSelectedFldctl(" + datePath + fldctlCd + ")");
    return Repository.get(
      `${resource}/rw/detail/fldctl/` + datePath + fldctlCd + ".json"
    );
  },
  /**
   *  都道府県別河川予警報一覧情報取得
   *  @param {*} prefCd 都道府県コード
   *  @param {*} appTime 取得日時
   */
  getRiverWarnPref(prefCd, appTime) {
    let datePath = Util.formatDate(appTime, "YYYYMMDD/HHmm/");
    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    logger.debug("json getRiverWarnPref(" + datePath + prefCd + ")");
    return Repository.get(
      `${resource}/rw/list/pref/` + datePath + prefCd + ".json"
    );
  },
  /**
   *  河川予警報危険度情報取得
   *  @param {*}
   *  @param appTime 取得日時
   */
  getRiverWarnsLvl(appTime) {
    let datePath = Util.formatDate(appTime, "YYYYMMDD/HHmm/");
    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    logger.debug("json getRiverWarnsLvl(" + datePath + ")");
    return Repository.get(`${resource}/rw/lvl/` + datePath + "rwLv.json");
  },
  /**
   *  観測所別河川予警報一覧取得
   * @param {*} obsFcd 伝送記号
   * @param {*} appTime 取得日時
   */
  getObsRiverWarnInfo(obsFcd, appTime) {
    let datePath = Util.formatDate(appTime, "YYYYMMDD/HHmm/");
    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    logger.debug("json getObsRiverWarnInfo(" + datePath + obsFcd + ")");
    return Repository.get(
      `${resource}/rw/list/obs/` + datePath + obsFcd + ".json"
    );
  },
};
